module.exports = __webpack_public_path__ + "img/puzzle_14.909d0e14.png";